import { ValidatorFn, Validators } from '@angular/forms';
import { DownloadType } from '../../../dto/enum/download-type.enum';
import { IFormProvider } from '../../form.provider';
import { POST_URL_REGEXP } from '../../../../../validation/const';

export abstract class AbstractMediaFormProvider implements IFormProvider {
  abstract getType: () => DownloadType;
  abstract getErrorTip: () => string;
  abstract getPlaceholder: () => string;

  public getValidators = (): ValidatorFn[] => [
    Validators.minLength(1),
    Validators.maxLength(192),
    Validators.pattern(POST_URL_REGEXP),
  ];

  public getOnInput(): (event: Event) => string {
    return (event: Event): string => {
      const htmlInputElement: HTMLInputElement = <HTMLInputElement>event.target;
      return htmlInputElement.value?.trim();
    };
  }
}
